import { breakpoints, colors, spacing } from '../../../utils/styleguide';
import styled from '@emotion/styled';
import Typography from '../text/Typography';

import SectionTitle from '../SectionTitle';
import Container from './Container';

const StyledContainer = styled(Container)`
  display: flex;
  flex-direction: column;
  gap: ${spacing[6]}px;
`;

const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing[3]}px;

  ${breakpoints.desktop} {
    padding: 0 ${spacing[5]}px;
  }
`;

type Props = {
  sectionTitle: string;
  pillar?: {
    name: string;
    description?: string;
  };
  approaches?: {
    name: string;
    description?: string;
  }[];
};

export default function PillarAndApproachesLayout({ sectionTitle, pillar, approaches }: Props) {
  return (
    <StyledContainer backgroundColor={colors.grey50}>
      <SectionTitle title={sectionTitle} />
      {pillar && (
        <Section>
          <Typography variant="h3">{pillar.name}</Typography>
          <Typography color={colors.blackSecondary} variant="body">
            {pillar.description}
          </Typography>
        </Section>
      )}
      {approaches?.map((approach) => (
        <Section key={approach.name}>
          <Typography variant="h5Bold">{approach.name}</Typography>
          <Typography color={colors.blackSecondary} variant="body">
            {approach.description}
          </Typography>
        </Section>
      ))}
    </StyledContainer>
  );
}
